const fields = {
    config: {columns: 1},
    fields: [
        {
            name: "name",
            label: 'Nazwa',
            column: 1,
            mandatory: true

        },
        {
            name: "description",
            label: "Opis",
            column: 1,
            type: "textarea",
            maxLength: 2000,
            rows: 15
        },
        {
            name: "guestsCount",
            label: "Goście",
            column: 1,
            type: "counter"
        },
        {
            name: "bedsCount",
            label: "Łóżka",
            column: 1,
            type: "counter"
        },
        {
            name: "bedroomsCount",
            label: "Sypialnie",
            column: 1,
            type: "counter"
        },
        {
            name: "bathroomCount",
            label: "Łazienki",
            column: 1,
            type: "counter"
        },
        {
            name: "mainImage",
            type: "unvisible"
        },
        {
            name: "images",
            type: "unvisible"
        },
        {
            name: "amenities",
            type: "unvisible"
        },
        {
            name: "rules",
            type: "unvisible"
        },
        {
            name: "checkinInstruction",
            type: "unvisible"
        },

        {
            name: "googleMapsUrl",
            type: "unvisible"
        },
        {
            name: "googleMapMailsUrl",
            type: "unvisible"
        },
        {
            name: "bookingCalendarUrl",
            type: "unvisible"
        },
    ]
};

export default fields;
